function initInstantSubscriptionPrice(plansJsonId, priceClass) {
  var priceObserver = null;

  function getPlans() {
    var el = document.getElementById(plansJsonId);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function getPriceForPlan(planId) {
    var plans = getPlans();
    if (!plans) return null;
    var entry = plans.find(function (p) { return String(p.sellingPlanId) === String(planId); });
    return entry ? entry.price : null;
  }

  function holdPrice(targetPrice) {
    var priceEl = document.querySelector('.' + priceClass);
    if (!priceEl) return;

    priceEl.textContent = targetPrice;

    if (priceObserver) priceObserver.disconnect();
    priceObserver = new MutationObserver(function () {
      if (priceEl.textContent !== targetPrice) {
        priceEl.textContent = targetPrice;
      }
    });
    priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
  }

  // Capture phase so Instant's stopPropagation cannot block us
  document.addEventListener('click', function (event) {
    var node = event.target;
    while (node && node !== document.documentElement) {
      var planId = node.getAttribute && node.getAttribute('data-instant-selling-plan-id');
      if (planId) {
        if (planId === 'one-time-purchase') {
          if (priceObserver) { priceObserver.disconnect(); priceObserver = null; }
        } else {
          var price = getPriceForPlan(planId);
          if (price) holdPrice(price);
        }
        return;
      }
      node = node.parentElement;
    }
  }, true);
}